import { useForm } from 'react-hook-form'
import Form from '../../components/Form'
import FormItem from '../../components/Form/FormItem'
import Button from '../../components/General/Button'
import InputText from '../../components/Inputs/InputText'
import Select from '../../components/Inputs/Select'

const PaymentForm: React.FC<IPaymentForm> = ({ onSubmitProp, onCloseProp, type}) => {
  const onSubmit = (value) => {
    onSubmitProp(value)
  }

  const form = useForm()
  const options = [{ text: 'Venezuela', value: 'ven' }]

  return (
    <Form form={form} onSubmit={onSubmit} classes="gap-x-6">
    <label style={{fontWeight: 700}} className="mb-3">{type}</label>
      <FormItem name="name" classes="col-span-12">
        <Select options={options} label="Tipo" />
      </FormItem>

      <FormItem name="name" classes="col-span-12">
        <Select options={options} label="Banco" />
      </FormItem>

      <FormItem name="reference" classes="col-span-12">
        <InputText label="Referencia" isUpperValue={false} />
      </FormItem>

      <div
        style={{ backgroundColor: '#DEE6EA', width: '100%', height: 1 }}
        className="col-span-12 my-4"
      ></div>

      <Button
        type="outline"
        classes="col-span-6"
        onClick={() => onCloseProp()}
        htmlType="button"
      >
        Cancelar
      </Button>
      <Button type="primary" classes="col-span-6" htmlType="submit">
        Guardar
      </Button>
    </Form>
  )
}

interface IPaymentForm {
  onSubmitProp: Function
  onCloseProp: Function
  type: string | null
}

export default PaymentForm
